import styled from "styled-components";
import { responsive } from "../../../../../styles/constants.style";

export const CPDashboardHeaderWrapper = styled.div`
  margin: 4px 0px 16px;

  ${responsive.MOBILE`
    margin: 0;
  `}
  .header-right {
    text-align: end;
    margin-top: 16px;

    ${responsive.MOBILE`
      margin-top: 0;
    `}

    .header-right-button {
      ${responsive.MOBILE`
        width: 100%;
        margin-bottom: 0;
      `}
    }
  }
`;
